export const WF_CONDITION_OPS = {
  number: [
    { value: 'eq', label: '等于' },
    { value: 'gte', label: '大于等于' },
    { value: 'lte', label: '小于等于' },
    { value: 'gt', label: '大于' },
    { value: 'lt', label: '小于' }
  ],
  select: [
    { value: 'eq', label: '等于' },
    { value: 'in', label: '属于' }
  ]
}

export function opsForValueType(valueType) {
  return valueType === 'number' ? WF_CONDITION_OPS.number : WF_CONDITION_OPS.select
}

export function opLabel(op) {
  const all = [...WF_CONDITION_OPS.number, ...WF_CONDITION_OPS.select]
  const hit = all.find(o => o.value === op)
  return hit ? hit.label : op
}

export function parseConditionJson(json) {
  if (!json || !String(json).trim()) return { logic: 'and', rules: [] }
  try {
    const obj = JSON.parse(json)
    if (!obj || typeof obj !== 'object') return { logic: 'and', rules: [] }
    return {
      logic: obj.logic === 'or' ? 'or' : 'and',
      rules: (obj.rules || []).map(r => ({
        field: r.field || '',
        op: r.op || 'eq',
        value: normalizeRuleValue(r.value, r.op)
      }))
    }
  } catch (e) {
    return { logic: 'and', rules: [] }
  }
}

function normalizeRuleValue(value, op) {
  if (op === 'in') {
    if (Array.isArray(value)) return value.map(v => String(v))
    if (value == null || value === '') return []
    return String(value).split(',').map(s => s.trim()).filter(Boolean)
  }
  return value == null ? '' : value
}

export function buildConditionJson(condition) {
  const rules = (condition.rules || [])
    .filter(r => r.field && r.op)
    .map(r => {
      const item = { field: r.field, op: r.op }
      if (r.op === 'in') {
        const arr = Array.isArray(r.value) ? r.value : []
        item.value = arr.filter(v => v != null && String(v).trim() !== '')
      } else if (typeof r.value === 'number') {
        item.value = r.value
      } else {
        item.value = r.value == null ? '' : String(r.value).trim()
      }
      return item
    })
    .filter(r => (r.op === 'in' ? Array.isArray(r.value) && r.value.length > 0 : r.value !== '' && r.value != null))
  if (!rules.length) return ''
  return JSON.stringify({ logic: condition.logic === 'or' ? 'or' : 'and', rules })
}

export function formatConditionText(condition, fieldOptions, { deptOptions = [], userOptions = [] } = {}) {
  const rules = (condition.rules || []).filter(r => r.field)
  if (!rules.length) return '无（始终匹配）'
  const fieldLabel = field => {
    const hit = (fieldOptions || []).find(f => f.field === field)
    return hit ? hit.label : field
  }
  const valueLabel = rule => {
    const meta = (fieldOptions || []).find(f => f.field === rule.field)
    const vt = meta ? meta.valueType : 'text'
    if (rule.op === 'in') {
      const ids = Array.isArray(rule.value) ? rule.value : []
      if (vt === 'dept') {
        return ids.map(id => {
          const d = deptOptions.find(x => String(x.departId) === String(id))
          return d ? d.departName : id
        }).join('、')
      }
      if (vt === 'user') {
        return ids.map(id => {
          const u = userOptions.find(x => String(x.id) === String(id))
          return u ? u.name : id
        }).join('、')
      }
      return ids.join('、')
    }
    if (vt === 'dept') {
      const d = deptOptions.find(x => String(x.departId) === String(rule.value))
      return d ? d.departName : rule.value
    }
    if (vt === 'user') {
      const u = userOptions.find(x => String(x.id) === String(rule.value))
      return u ? u.name : rule.value
    }
    return rule.value
  }
  const joiner = condition.logic === 'or' ? ' 或 ' : ' 且 '
  return rules.map(r => fieldLabel(r.field) + ' ' + opLabel(r.op) + ' ' + valueLabel(r)).join(joiner)
}
